exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".popover-content{text-align:left;width:308px;margin:0 auto;padding:24px}.popover-content.no-content-padding{width:292px;padding:16px 8px}.popover-content h4{margin-top:.4em;margin-bottom:1.3em}.popover-content p:last-child{margin-bottom:.5em}", ""]);

